import store from "@/store.js";

import ImportXLS from "@/components/ImportXLS";
import CreateDisciplines from "@/components/CreateDisciplines";

export default {
  id: 2,
  adminOnly: false,
  type: "courses",
  title: "Cursos",
  deleteEntriesAllowed: true,
  actions: {
    get: "getCourses",
    post: "postCourse",
    patch: "patchCourse",
    delete: "deleteCourse",
  },
  headers: [
    {
      title: "ID Curso",
      field: {
        name: "ID_Curso",
        type: null,
      },
    },
    {
      title: "ID Localización",
      field: {
        name: "ID_Location",
        type: "select",
        multiple: false,
        options: "locations",
        optionName: "ID_Location",
        editable: false,
      },
    },
    {
      title: "Grupos",
      field: {
        name: "grupos",
        type: "select",
        multiple: true,
        options: "groups",
        optionName: "descripcion",
        editable: true,
      },
    },
    {
      title: "Descripción",
      field: {
        name: "descripcion",
        type: "select",
        multiple: false,
        options: "course_types",
        optionName: "descripcion",
        editable: false,
      },
    },
    {
      title: "Orden curso",
      field: {
        name: "orden",
        type: "number",
        editable: true,
      },
    },
  ],
  options: [
    {
      title: "Descargar plantilla XLS Alumnos",
      type: "anchor",
      href: "server/templates/alumnos.xls",
    },
    {
      title: "Importar alumnos",
      type: "function",
      function: (entry) => {
        store.commit("showModal", {
          component: ImportXLS,
          title: `Importar alumnos a ${entry.ID_Curso}`,
          props: {
            entry,
            import: "students",
          },
        });
      },
    },
    {
      title: "Crear asignaturas",
      type: "function",
      function: (entry) => {
        store.commit("showModal", {
          component: CreateDisciplines,
          title: `Crear asignaturas de ${entry.ID_Curso}`,
          props: {
            course: entry.ID_Curso,
          },
        });
      },
    },
    {
      title: "Descargar plantilla XLS Asignaturas",
      type: "anchor",
      href: "server/templates/asignaturas.xls",
    },
    {
      title: "Importar asignaturas",
      type: "function",
      function: (entry) => {
        store.commit("showModal", {
          component: ImportXLS,
          title: `Importar asignaturas a ${entry.ID_Curso}`,
          props: {
            entry,
            import: "disciplines",
          },
        });
      },
    },
  ],
  filters: [
    {
      title: "ID Curso",
      name: "ID_Curso",
      type: "select",
      options: "courses_distinct",
      fromExtras: true,
      optionName: "ID_Curso",
    },
    {
      title: "ID Localización",
      name: "ID_Location",
      type: "select",
      options: "locations",
      fromExtras: true,
      optionName: "ID_Location",
    },
    {
      title: "Descripción",
      name: "descripcion",
      type: "select",
      options: "description_distinct",
      fromExtras: true,
      optionName: "descripcion",
    },
    {
      title: "Orden",
      name: "orden",
      type: "select",
      options: "order_distinct",
      fromExtras: true,
      optionName: "orden",
    },
  ],
};
